"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coreConditionReducer = exports.coreConditionActions = exports.TYPES_CORE_CONDITION = void 0;
var _reduxActions = require("redux-actions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CORE_CONDITION = 'coreCondition';
const TYPES_CORE_CONDITION = exports.TYPES_CORE_CONDITION = {
  CLEAR: CORE_CONDITION + 'Clear',
  SET_DIRTY: CORE_CONDITION + 'SetDirty'
};
const INIT_STATE = {
  isDirty: false
};
const coreConditionActions = exports.coreConditionActions = (0, _reduxActions.createActions)({
  [TYPES_CORE_CONDITION.SET_DIRTY]: function () {
    return {
      isDirty: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES_CORE_CONDITION.CLEAR);
const coreConditionReducer = exports.coreConditionReducer = (0, _reduxActions.handleActions)({
  [TYPES_CORE_CONDITION.CLEAR]: () => {
    return _objectSpread({}, INIT_STATE);
  },
  [TYPES_CORE_CONDITION.SET_DIRTY]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      isDirty: action.payload.isDirty
    });
  }
}, INIT_STATE);